import { CityContentMapRO } from '@routellers/types/dist/city/city-content-map.ro';

import { ApiMethodDeclaration } from '..';

export const contentMap: ApiMethodDeclaration<number, CityContentMapRO> = (id) => ({
    url: `/cities/${id}/content-map`,
    method: 'GET',
});
